/* eslint-disable no-prototype-builtins */
import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";
import deepmerge from "deepmerge";
import { getTranslations } from "shared/api";
import globalMessages from "./global.json";

export interface GroupedLocaleMessages {
  [key: string]: LocaleMessages;
}

export interface KeyedMessages {
  key: string;
  messages: GroupedLocaleMessages;
}

export const allMessages: LocaleMessages = {};

function addLocalisation(km: KeyedMessages): void {
  for (const lang in km.messages) {
    if (!allMessages.hasOwnProperty(lang)) allMessages[lang] = {};
    if (allMessages[lang].hasOwnProperty(km.key)) throw "key exists";
    allMessages[lang][km.key] = km.messages[lang];
  }
}

addLocalisation({ key: "global", messages: globalMessages });

export function loadLocalisations(keyedMsgArr: KeyedMessages[]): void {
  for (const km of keyedMsgArr) addLocalisation(km);
}

let instance: VueI18n;

export const getInstance = (): Readonly<VueI18n> => {
  return instance;
};

export default async (messages?: LocaleMessages): Promise<VueI18n> => {
  Vue.use(VueI18n);

  messages =
    messages === undefined ? allMessages : deepmerge(allMessages, messages);

  messages.nl = deepmerge(messages.nl, await getTranslations("nl"));

  instance = new VueI18n({
    locale: "nl", // set locale
    messages, // set locale messages
  });

  return instance;
};
